import React, { useEffect, useState } from "react";
import { MdDelete, MdModeEditOutline } from "react-icons/md";
import "../../css/Admin-Skills/AdminSkillsCard.css";
import AdminEditSkills from "./AdminEditSkills";
import { toast } from "react-toastify";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../firebase";

const AdminSkillsCard = ({ data, fetchData,projectKey }) => {
  const [editProject, setEditProject] = useState(false);

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this Skill?")) {
      try {
        await deleteDoc(doc(db, "skills", projectKey));
        toast.success("Skill deleted successfully");
        fetchData();
      } catch (error) {
        toast.error("Failed to delete Skill");
      }
    }
  };


  return (
    <div className="product-container">
      <div className="product-card">
        <div className="product-image-div">
          <img
            src={data.skillsLogo}
            alt={data.skillsLogo}
            className="product-image"
          />
        </div>
        <h1 className="product-name">{data.skillsPercentage}%</h1>
        <p className="product-description">{data.skillsName}</p>
        <div className="product-buttons">
          

          <div className="edit-button" onClick={() => setEditProject(true)}>
            <MdModeEditOutline style={{fontSize:'1.5rem' }}/>
          </div>

          <div className="delete-button" onClick={handleDelete}>
            <MdDelete style={{ fontSize: "1.5rem" ,color:"white"}} />
          </div>

        </div>
      </div>

      {editProject && (
                <AdminEditSkills onClose={() => setEditProject(false)} productData={data} fetchData={fetchData} projectKey={projectKey}/>
            )}
    </div>
  );
};

export default AdminSkillsCard;
